import { render, staticRenderFns } from "./ResultDistributionList.vue?vue&type=template&id=05d15dd6&scoped=true&"
import script from "./ResultDistributionList.vue?vue&type=script&lang=ts&"
export * from "./ResultDistributionList.vue?vue&type=script&lang=ts&"
import style0 from "./ResultDistributionList.vue?vue&type=style&index=0&id=05d15dd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d15dd6",
  null
  
)

export default component.exports